import { AbstractControl, ValidatorFn } from '@angular/forms';

export const passwordPattern = (): ValidatorFn => {
    return (control: AbstractControl) => {
        if (!control.value) {
            return null;
        }

        const passwordPattern = {
            hasNumber: /\d/.test(control.value),
            hasUpper: /[A-Z]/.test(control.value),
            hasLower: /[a-z]/.test(control.value),
            hasSymbol: /[^0-9a-zA-Z+]/.test(control.value),
        };
        const numberOfSuccessfulChecks = ['hasNumber', 'hasUpper', 'hasLower', 'hasSymbol'].reduce((accumulator, currentValue) => {
            return accumulator + Number((passwordPattern as { [key: string]: boolean })[currentValue]);
        }, 0) as unknown as number;

        const valid = numberOfSuccessfulChecks >= 3;

        if (!valid) {
            return {
                passwordPattern: {
                    ...passwordPattern,
                    numberOfFailedChecks: Object.keys(passwordPattern).length - numberOfSuccessfulChecks,
                },
            };
        }

        return null;
    };
};
